var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"number-scroll-grow"},[_c('span',{ref:"numberScroll",staticClass:"number-scroll",attrs:{"data-time":_vm.time,"data-value":_vm.value}},[_vm._v(" 0 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }